import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Card, Placeholder } from 'react-bootstrap';
import PropTypes from 'prop-types';
import useToken from 'hooks/useToken';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

const SubscriptionInfo = ({ idSuscripcion, info, onRefreshInfo }) => {
    const { token } = useToken();
    info = info || {};

    // Si 'info' no tiene datos todavía, asumimos que está cargando
    const isLoading = Object.keys(info).length === 0;

    //PETICIONES PARA LA EDICION DEL STRIPE
    const [isEditing, setIsEditing] = useState(false);
    const [nuevoStripeId, setNuevoStripeId] = useState("");

    //PARA COPIAR
    const [isCopied, setIsCopied] = useState(false);
    const [isLinkCopied, setIsLinkCopied] = useState(false);
    const [urlBasePagos, setUrlBasePagos] = useState('http://localhost:5173/?');

    //FETCH PARA LOS DATOS DEL STRIPEID
    const GuardarEdicion = async () => {
        try {
            const response = await fetch(`/api/Suscripciones/ActualizarStripeId`, {
                method: "POST",
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "idSuscripcion": parseInt(idSuscripcion), "vStripeSubscriptionId": nuevoStripeId

                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    setIsEditing(false); // Salir del modo edición
                    if (onRefreshInfo) onRefreshInfo(); // Volver a consultar la BD para refrescar la vista
                    toast.success("¡Stripe ID actualizado correctamente!", {
                        theme: 'colored',
                    });
                } else {
                    console.log("Error al actualizar:", data.vMessage);
                    toast.error("Error al actualizar el Stripe ID");
                }
            }
        } catch (error) {
            console.error("Error de conexión al guardar", error);
        }
    };

    // Eliminado: ObtenerInfo (ahora se obtiene desde el componente padre)


    const obtenerUrlBasePagos = async () => {
        try {
            const response = await fetch('/api/Suscripciones/ObtenerUrlBasePagos', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            if (data.iResponseType === 1 && data.detalles?.urlBase) {
                setUrlBasePagos(data.detalles.urlBase);
            }
        } catch (error) {
            console.error('Error obteniendo URL base de pagos:', error);
        }
    };

    useEffect(() => {
        obtenerUrlBasePagos();
    }, []);

    const fallbackCopyTextToClipboard = (text) => {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            document.execCommand('copy');
            setIsLinkCopied(true);
            setTimeout(() => setIsLinkCopied(false), 2000);
            toast.success('Link de pago copiado.', { theme: 'colored' });
        } catch (execError) {
            console.error('Error al copiar con execCommand:', execError);
            toast.error('No se pudo copiar el enlace. Por favor, cópialo manualmente.');
        }

        document.body.removeChild(textArea);
    };

    const copiarLinkPago = () => {
        if (!info.vUUIDEmpresa || !info.vUUIDLicencia || !info.vUUIDSuscripcion) {
            toast.error('Faltan datos para generar el enlace (UUIDs faltantes).');
            return;
        }

        const payload = {
            idProductoPrecio: info.idProductoPrecio || 0,
            idClienteAkasia: Number(info.idClienteAkasia || 0),
            esSuscripcion: 1,
            uuidEmpresa: info.vUUIDEmpresa,
            uuidLicencia: info.vUUIDLicencia,
            uuidSuscripcion: info.vUUIDSuscripcion
        };

        const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
        const paymentUrl = `${urlBasePagos}vSub=${encodeURIComponent(encoded)}`;

        try {
            navigator.clipboard.writeText(paymentUrl).then(() => {
                setIsLinkCopied(true);
                setTimeout(() => setIsLinkCopied(false), 2000);
                toast.success('Link de pago copiado.', { theme: 'colored' });
            }).catch(() => {
                fallbackCopyTextToClipboard(paymentUrl);
            });
        } catch (error) {
            fallbackCopyTextToClipboard(paymentUrl);
        }
    };

    const formateaFecha = (fecha) => {
        if (!fecha) return '';

        const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        const date = new Date(fecha);

        const dia = date.getUTCDate();
        const mes = meses[date.getUTCMonth()];
        const anio = date.getUTCFullYear();

        return `${dia} ${mes} ${anio}`;
    };
    return (
        <Card className="border-0 shadow-sm rounded-3 mb-4" style={{ fontFamily: '"Open Sans", sans-serif' }}>
            <Card.Body className="p-4">
                {/* SECCIÓN CLIENTE */}
                {(isLoading || info.idClienteAkasia) && (
                    <Row className="mb-4 pb-4 border-bottom mx-0">
                        <Col className="px-0">
                            <div className="d-flex align-items-center gap-3">
                                <div className="d-flex justify-content-center align-items-center" style={{ width: '48px', height: '48px' }}>
                                    {isLoading ? (
                                        <Placeholder as="div" animation="glow" style={{ width: '100%', height: '100%' }}>
                                            <Placeholder xs={12} className="rounded-circle h-100 w-100 bg-secondary" style={{ opacity: 0.5 }} />
                                        </Placeholder>
                                    ) : (
                                        <img src="/img/cliente48.png" alt="Cliente" style={{ width: '100%', height: 'auto', objectFit: 'contain' }} />
                                    )}
                                </div>
                                <div className="d-flex flex-column justify-content-center flex-grow-1">
                                    <div className="d-flex align-items-center mb-1">
                                        <h5 className="mb-0" style={{ fontWeight: 700 }}>
                                            Cliente
                                        </h5>
                                        {!isLoading && (
                                            <span className="ms-2 border text-muted rounded px-2" style={{ fontSize: '0.75rem', fontWeight: 600 }}>
                                                #{info.idClienteAkasia}
                                            </span>
                                        )}
                                    </div>
                                    <div className="d-flex align-items-center mb-0">
                                        {isLoading ? (
                                            <Placeholder as="span" animation="glow" className="w-100">
                                                <Placeholder xs={8} bg="secondary" style={{ opacity: 0.5 }} />
                                            </Placeholder>
                                        ) : (
                                            <a href={`/clientes/detalle/${info.idClienteAkasia}`} target="_blank" rel="noopener noreferrer" className="fw-bold text-primary text-decoration-none text-uppercase" style={{ fontSize: '0.95rem' }}>
                                                {info.vNombreCliente || 'VER DETALLES DEL CLIENTE'}
                                            </a>
                                        )}
                                    </div>
                                    {isLoading ? (
                                        <Placeholder as="span" animation="glow" className="w-100 mt-1">
                                            <Placeholder xs={5} bg="secondary" style={{ opacity: 0.5 }} />
                                        </Placeholder>
                                    ) : info.vEmail ? (
                                        <a href={`mailto:${info.vEmail}`} className="text-primary text-decoration-underline" style={{ fontSize: '0.8rem' }}>
                                            <i className="fas fa-envelope me-1"></i>{info.vEmail}
                                        </a>
                                    ) : (
                                        <span className="text-muted fst-italic" style={{ fontSize: '0.8rem' }}>
                                            Sin correo registrado
                                        </span>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                )}

                <h6 className="fw-bold mb-4 d-flex align-items-center" style={{ fontSize: '1rem' }}>
                    <FontAwesomeIcon icon="info-circle" className="text-primary me-2" />
                    Información de la Suscripción
                </h6>

                <div className="mb-4">
                    <span className="text-muted fw-bold d-block text-uppercase mb-2" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                        STRIPE ID
                    </span>

                    <div className="d-flex align-items-center justify-content-between p-2 rounded border">
                        {isEditing && !isLoading ? (
                            <>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={nuevoStripeId}
                                    onChange={(e) => setNuevoStripeId(e.target.value)}
                                />
                                <div className="text-nowrap ms-2">
                                    <Button variant="link" className="p-0 text-success me-3" onClick={() => { GuardarEdicion(); }}>
                                        <FontAwesomeIcon icon="check" />
                                    </Button>
                                    <Button variant="link" className="p-0 text-danger" onClick={() => { setIsEditing(false); }}>
                                        <FontAwesomeIcon icon="times" />
                                    </Button>
                                </div>
                            </>
                        ) : (
                            <>
                                <span className="font-monospace text-truncate d-block" style={{ fontSize: '0.85rem' }}>
                                    {isLoading ? <Placeholder as="span" animation="glow"><Placeholder xs={8} /></Placeholder> : (info.vStripeSubscriptionId || 'Sin Registro')}
                                </span>
                                {!isLoading && (
                                    <div className="text-nowrap ms-2">
                                        <Button variant="link" className="p-0 text-primary me-3" onClick={() => {
                                            setIsEditing(true);
                                            setNuevoStripeId(info.vStripeSubscriptionId);
                                        }}>
                                            <FontAwesomeIcon icon="edit" />
                                        </Button>
                                        <Button
                                            variant="link"
                                            className="p-0 text-secondary"
                                            onClick={() => {
                                                if (info.vStripeSubscriptionId) {
                                                    navigator.clipboard.writeText(info.vStripeSubscriptionId);


                                                    setIsCopied(true);
                                                    setTimeout(() => {
                                                        setIsCopied(false);
                                                    }, 2000)
                                                }
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={isCopied ? "check" : "copy"}
                                                className={isCopied ? "text-success" : ""}
                                            />
                                        </Button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>

                {/* Link de Pago - Solo se muestra si NO hay Stripe ID y la suscripción está ACTIVA */}
                {(!isLoading && !info.vStripeSubscriptionId && info.vEstadoSuscripcion === 'ACTIVA') && (
                    <Row className="mb-3 border-bottom pb-3 mx-0">
                        <Col xs={6} className="text-muted px-0" style={{ fontSize: '0.85rem' }}>Link de Pago</Col>
                        <Col xs={6} className="text-end px-0" style={{ fontSize: '0.85rem' }}>
                            <Button
                                variant="link"
                                className="p-0 text-primary text-decoration-none fw-semibold"
                                onClick={copiarLinkPago}
                                disabled={!info.vUUIDSuscripcion}
                            >
                                <FontAwesomeIcon icon={isLinkCopied ? "check" : "link"} className={`me-2 ${isLinkCopied ? "text-success" : ""}`} />
                                {isLinkCopied ? "¡Copiado!" : "Copiar enlace"}
                            </Button>
                        </Col>
                    </Row>
                )}

                {/* Total */}
                <Row className="mb-3 border-bottom pb-3 mx-0">
                    <Col xs={6} className="text-muted px-0" style={{ fontSize: '0.85rem' }}>Total Suscripción</Col>
                    <Col xs={6} className={`text-end px-0 ${isLoading ? '' : info.dTotal ? 'fw-bold' : 'text-muted fst-italic'}`} style={{ fontSize: '0.85rem' }}>
                        {isLoading ? <Placeholder as="span" animation="glow"><Placeholder xs={4} bg="secondary" /></Placeholder> : info.dTotal ? `$${info.dTotal} ${info.vMoneda || ''}` : 'Sin cobro registrado'}
                    </Col>
                </Row>

                {/* Moneda */}
                <Row className="mb-3 border-bottom pb-3 mx-0">
                    <Col xs={6} className="text-muted px-0" style={{ fontSize: '0.85rem' }}>Moneda</Col>
                    <Col xs={6} className={`text-end px-0 ${isLoading ? '' : 'fw-semibold'}`} style={{ fontSize: '0.85rem' }}>
                        {isLoading ? <Placeholder as="span" animation="glow"><Placeholder xs={3} bg="secondary" /></Placeholder> : info.vMoneda || 'Sin definir'}
                    </Col>
                </Row>

                {/* Periodo de Cobro */}
                <Row className="mb-3 border-bottom pb-3 mx-0">
                    <Col xs={6} className="text-muted px-0" style={{ fontSize: '0.85rem' }}>Periodo de Cobro</Col>
                    <Col xs={6} className="text-end px-0" style={{ fontSize: '0.85rem' }}>
                        {isLoading ? (
                            <Placeholder as="span" animation="glow"><Placeholder xs={5} bg="secondary" /></Placeholder>
                        ) : info.vTipoRenovacion ? (
                            <span className="badge bg-primary text-white text-capitalize">{info.vTipoRenovacion}</span>
                        ) : (
                            <span className="text-muted fst-italic">Sin definir</span>
                        )}
                    </Col>
                </Row>

                {/* Fecha de Inicio */}
                <Row className="mb-3 border-bottom pb-3 mx-0">
                    <Col xs={6} className="text-muted px-0" style={{ fontSize: '0.85rem' }}>Fecha de Inicio</Col>
                    <Col xs={6} className={`text-end px-0 ${isLoading ? '' : (info.dCreatedDate || info.dFechaAlta) ? 'fw-semibold' : 'text-muted fst-italic'}`} style={{ fontSize: '0.85rem' }}>
                        {isLoading ? <Placeholder as="span" animation="glow"><Placeholder xs={6} bg="secondary" /></Placeholder> : (info.dCreatedDate || info.dFechaAlta) ? formateaFecha(info.dCreatedDate || info.dFechaAlta) : 'Sin fecha de inicio'}
                    </Col>
                </Row>

                {/* Siguiente Pago */}
                <Row className="mb-3 border-bottom pb-3 mx-0">
                    <Col xs={6} className="text-muted px-0" style={{ fontSize: '0.85rem' }}>Siguiente Pago</Col>
                    <Col xs={6} className={`text-end px-0 ${isLoading ? '' : info.dProximoPago ? 'text-primary fw-semibold' : 'text-muted fst-italic'}`} style={{ fontSize: '0.85rem' }}>
                        {isLoading ? <Placeholder as="span" animation="glow"><Placeholder xs={6} bg="secondary" /></Placeholder> : info.dProximoPago ? formateaFecha(info.dProximoPago) : 'Sin próximo pago'}
                    </Col>
                </Row>

                {/* Creada por */}
                <Row className="mb-3 border-bottom pb-3 mx-0">
                    <Col xs={6} className="text-muted px-0" style={{ fontSize: '0.85rem' }}>Creada por</Col>
                    <Col xs={6} className={`text-end px-0 ${isLoading ? '' : info.vCreatedUser ? 'fw-semibold' : 'text-muted fst-italic'}`} style={{ fontSize: '0.85rem' }}>
                        {isLoading ? <Placeholder as="span" animation="glow"><Placeholder xs={10} bg="secondary" /></Placeholder> : info.vCreatedUser || 'Sin creador registrado'}
                    </Col>
                </Row>

                {/* Cancelada por (Condicional) */}
                {(!isLoading && info.vCanceladoUser) && (
                    <Row className="mb-3 border-bottom pb-3 mx-0">
                        <Col xs={6} className="text-muted px-0" style={{ fontSize: '0.85rem' }}>Cancelada por</Col>
                        <Col xs={6} className="text-end px-0 text-danger fw-semibold" style={{ fontSize: '0.85rem' }}>
                            {info.vCanceladoUser}
                        </Col>
                    </Row>
                )}

                {/* Fecha Cancelación (Condicional) */}
                {(!isLoading && info.dFechaCancelacion) && (
                    <Row className="mb-3 border-bottom pb-3 mx-0">
                        <Col xs={6} className="text-muted px-0" style={{ fontSize: '0.85rem' }}>Fecha de cancelación</Col>
                        <Col xs={6} className="text-end px-0 text-danger fw-semibold" style={{ fontSize: '0.85rem' }}>
                            {formateaFecha(info.dFechaCancelacion)}
                        </Col>
                    </Row>
                )}

            </Card.Body>
        </Card>
    );
};

SubscriptionInfo.propTypes = {
    idSuscripcion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    info: PropTypes.object,
    onRefreshInfo: PropTypes.func
};

export default SubscriptionInfo;